<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-tabView>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_PRODUCTO' | translate}}">

      <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event.index)">
        <p-accordionTab header="{{ 'PRODUCTO.LBL_IDENTIFICACIONPRODUCTO' | translate }}" [selected]="tabSeleccionado === 'PRODUCTO'">

          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_CODIGO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.codigo}}</strong></label>

            <ng-container *ngIf="codeTipoProductoBancario == codigosProducto.INVERSION">
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_TIPO_PRODUCTO' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.tiposTitulosInversion}}</strong></label>
            </ng-container>

            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_NOMBREPRODUCTO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.nombre}}</strong></label>
          </div>

          <ng-container *ngIf="codeTipoProductoBancario != codigosProducto.PASARELA">

          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_MODALIDAD' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.nombreModalidades}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_ALIADOS' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.indicadorComercializacionAliados ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>

          </div>
          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_ESPECIAL' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.indicadorEspecial ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_OFICINAS' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorComercializacionOficinas ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_FECHAINICIAL' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.fechaInicioVigencia}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_FECHAFINAL' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.fechaFinVigencia}}</strong></label>
          </div>
          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_TIPOCUPO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.nombreTipoCupo}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_CLASIFICACIONPRODUCTO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.nombreClasificacion}}</strong></label>
          </div>
          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_ACTAJUNTA' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.codigoActaAprobacion}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_FECHAAPROBACIONACTA' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.fechaAprobacionActa}}</strong></label>
          </div>

          <div class="grid" *ngIf="codeTipoProductoBancario != codigosProducto.AHORRO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_MONTOMINIMO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.montoMinimo}} ({{ 'LBL_SMLV' | translate }})</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_MONTOMAXIMO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.montoMaximo}} ({{ 'LBL_SMLV' | translate }})</strong></label>
          </div>
          <div class="grid" *ngIf="codeTipoProductoBancario != codigosProducto.AHORRO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_PLAZOMINIMO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.plazoMinimo}} ({{ 'LBL_MESES' | translate }})</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_PLAZOMAXIMO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.plazoMaximo}} ({{ 'LBL_MESES' | translate }})</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_ROTATIVO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorRotativo ? ('LBL_SI' | translate) : ('LBL_NO' | translate)}}</strong></label>
          </div>
          <p-fieldset legend="{{ 'PRODUCTO.LBL_FRECVARI' | translate }}" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <div class="grid col-12">
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_PLAZOMINIMOMES' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.plazoMinimoFrecuencia}}</strong></label>
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_PLAZOMAXIMOMES' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.plazoMaximoFrecuencia}}</strong></label>
            </div>
          </p-fieldset>

          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_MANEJATASA' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorManejaTasa ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_MANEJADCTOTASA' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorManejaDctoTasa ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>

          </div>
          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <label *ngIf="producto.indicadorManejaTasa" class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_TASA' | translate }}
              :</label>
            <label *ngIf="producto.indicadorManejaTasa" class="lg:col-3 col-6 md:col-8"><strong>{{producto.tasa}}</strong></label>

            <label *ngIf="producto.indicadorManejaTasa" class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_TASAMAXIMAESPECIAL' | translate }}:</label>
            <label *ngIf="producto.indicadorManejaTasa" class="lg:col-3 col-6 md:col-8"><strong>{{producto.tasaMaximaEspecial}}</strong></label>
          </div>

          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_DUPLICARDIRECCION' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorDuplicarDireccionNegocio ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_ICONO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.icono}}</strong></label>
          </div>
          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_APROBPLANPAGO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorAprobacionPlanPago ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'VISITA.LBL_AMORTIZACION' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.tipoAmortizacion}}</strong></label>
          </div>
          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_NOREQUIEREUNIDADCREDITO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{!producto.indicadorRequiereUnidadCredito ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_APLICAGARANTIAIDONEA' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorAplicaGarantiaIdonea ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">

            <ng-container *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_SEGUROSVOLUNTARIOSPREAPROBADOS' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorSeguroVoluntarioPreaprobado ? ('LBL_SI' | translate) : ('LBL_NO' |translate)}}</strong></label>
            </ng-container>

          </div>
          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_LIBRANZA' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorLibranza ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <ng-container *ngIf="producto.indicadorLibranza">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_TIPOCARTERA' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.tipoCartera}} </strong></label>
            </ng-container>
          </div>

          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_EJECUTIVO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorEjecutivo ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_FREELANCE' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorFreelance ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>

          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.CREDITO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_NOAPLICADESCPORPERFILRIESGO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorNoAplicaDescuentoPerfilRiesgo ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>

          <p-fieldset legend="{{ 'PRODUCTO.LBL_RANGOPAGO' | translate }}" *ngIf="producto.indicadorComercializacionOficinas">
            <div class="grid col-12">
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_DIAPRIMERPAGODE' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.diaDePrimerPago}}</strong></label>
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_DIAPRIMERPAGOHASTA' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.diaHastaPrimerPago}}</strong></label>
            </div>
          </p-fieldset>

          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_DESCRIPCION' | translate }}:</label>
            <label class="lg:col-9 col-6 md:col-8 "><strong>{{producto.descripcion}}</strong></label>
          </div>

          <div class="grid" *ngIf="codeTipoProductoBancario != codigosProducto.AHORRO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_ADJUNTO' | translate }}:</label>
            <a class="btn btn-default" style="max-width: 87%; overflow: hidden; display: grid; cursor: default">
              <i class="fa fa-file-o" *ngIf="!imagen" aria-hidden="true"></i>
              <img *ngIf="imagen" style="height: 100px" [src]="imagen" alt=""/>
              <small style="cursor: default; color: #606060">{{producto.nombreAdjuntoIcono}}</small>
            </a>
          </div>

          <div class="grid" *ngIf="codeTipoProductoBancario != codigosProducto.AHORRO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_RESENA' | translate }}:</label>
            <label class="lg:col-9 col-6 md:col-8 "><strong>{{producto.resenaDigital}}</strong></label>
          </div>

          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.AHORRO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_TIPOPRODUCTO_CUENTA' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.tipoCuentaAhorro}}</strong></label>
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_TIPOPRODUCTO_RENTABILIDAD' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.rentabilidad}}</strong></label>
          </div>

          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.AHORRO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_TIPOPRODUCTO_MEDIOS' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{mediosAsociados}}</strong></label>

              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_TIPOPRODUCTO_SOLICITUD_LLAVES' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8"><strong>{{solicitudesLlaves}}</strong></label>

          </div>

          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.INVERSION">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_TIPO_INTERESES' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{productoTiposIntereses}}</strong></label>

            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_CANAL_CDT' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.canalCDTS}}</strong></label>

            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_TIPOPRODUCTO_IMPUESTO_FINANCIERO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.impuestoFinanciero ? ('LBL_SI' | translate) : ('LBL_NO' | translate)}}</strong></label>

            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_RENOVACIÓN_AUTO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorAplicaRenovacionAutomatica ? ('LBL_SI' | translate) : ('LBL_NO' | translate)}}</strong></label>

            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_INDICADOR_BTN_PSE' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorBotonPse ? ('LBL_SI' | translate) : ('LBL_NO' | translate)}}</strong></label>
          </div>

          <div class="grid" *ngIf="codeTipoProductoBancario == codigosProducto.AHORRO && codeTipoCuentaAhorro == tiposCuentaAhorro.AHORRO_PROGRAMADO">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_INDICADOR_BTN_PSE' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorBotonPse ? ('LBL_SI' | translate) : ('LBL_NO' | translate)}}</strong></label>
          </div>

          </ng-container>

        </p-accordionTab>

        <p-accordionTab header="{{ 'PRODUCTO.LBL_SECCIONESPROCTO' | translate }}" [selected]="tabSeleccionado === 'INDICADORES'">
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_ALERTAS' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.indicadorAlertas ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_CONFIRVINCU' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorConfirmacionVinculacion ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_CUESTIONARIOS' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.indicadorCuestionario ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_DESEMBOLSO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorDesembolso ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_HOJAEVALUACION' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorHojaEvaluacion ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label *ngIf="producto.indicadorHojaEvaluacion" class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_FLUJOCAJA' | translate }}:</label>
            <label *ngIf="producto.indicadorHojaEvaluacion" class="lg:col-3 col-6 md:col-8 "><strong>{{producto.indicadorFlujoCaja ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_MONTOPORDESTINO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorMontoDestino ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_MONTOSPERFIL' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.indicadorMontoDestinoPerfil ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_REGLASNEGOCIO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorReglasNegocio ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_PUEDERENOVAR' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.indicadorRenovable ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_RESPALDO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorManejaGarantia ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_RESTRICCIONES' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.indicadorRestricciones ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>

          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_VOLUNTADPAGO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorVoluntadPago ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_CICLOINTERNO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{producto.indicadorCicloInterno ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO.LBL_FLUJODIGITAL' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorFlujoDigital ? ('LBL_SI' | translate) : ('LBL_NO' | translate)}}</strong></label>

            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PRODUCTO_ADJUNTO.LBL_TITULO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{producto.indicadorAplicaAdjunto ? ('LBL_SI' | translate) : ('LBL_NO' | translate)}}</strong></label>
          </div>

        </p-accordionTab>
      </p-accordion>


    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_ALERTAS' | translate}}" [disabled]="!producto" *ngIf="producto.indicadorAlertas">
      <app-producto-politica-alerta [producto]="producto" [verDetalle]="true"
                                    *ngIf="producto && producto.idProducto"></app-producto-politica-alerta>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_ACTIVIDADALIADO' | translate}}">
      <p-panel header="{{ 'PRODUCTOACTIVIDAD.LBL_ACTIVIDADES' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colActividades" [loading]="carTablaActividades"
                     [value]="lisProductoActividad" selectionMode="single" dataKey="idProductoActividad"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.nombreSegmento}}</td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_AUTORIZACIONES' | translate}}">
      <p-panel header="{{ 'PRODUCTO.LBL_AUTORIZACIONES' | translate}}">
        <p-accordion [multiple]="true" styleClass="ds-accordion" [activeIndex]="[0, 1]">
          <p-accordionTab header="{{ 'PRODUCTOAUTORIZACION.LBL_AUTORIZACIONES' | translate }}">
            <ng-container *ngTemplateOutlet="tablaAutorizacion; context: { $implicit: lisProductoAutorizacion }"></ng-container>
          </p-accordionTab>
          <p-accordionTab header="{{ 'PRODUCTOAUTORIZACION.LBL_CONTRATOS' | translate }}">
            <ng-container *ngTemplateOutlet="tablaAutorizacion; context: { $implicit: lisProductoAutorizacionContrato }"></ng-container>
          </p-accordionTab>
        </p-accordion>
      </p-panel>
      <ng-template #tablaAutorizacion let-lista>
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colAutorizacion" [loading]="carTablaAutorizacion"
                     [value]="lista" selectionMode="single" dataKey="idProductoActividad"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.nombreAutorizacion}}</td>
                  <td>{{row.nombrePlantilla}}</td>
                  <td>{{row.fase}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_CAMPOSDIGITAL' | translate}}"  *ngIf="!producto || producto.indicadorFlujoDigital">
      <app-flujos-creditos-digitales [producto]="producto" [flujoDigital]="canales.PRODUCTO"
                                     [esDetalle]="true"></app-flujos-creditos-digitales>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_MONTOS_TASAS' | translate}}" *ngIf="codeTipoProductoBancario == codigosProducto.INVERSION">
      <app-producto-montos-tasas [producto]="producto" [isDetail]="true"></app-producto-montos-tasas>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_CONFIRVINCU' | translate}}" *ngIf="!producto || producto.indicadorConfirmacionVinculacion">
      <p-panel header="{{ 'PRODUCTO.LBL_CONFIRVINCU' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colConfirmacionVinculacion" [loading]="carTablaConfirmacionVinculacion"
                     [value]="lisProductoConfirmacionVinculacion" selectionMode="single" dataKey="idProductoControl"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.nombreTipoVinculacion}}</td>
                  <td>{{row.nombreCuestionario}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_CONTROLES' | translate}}">
      <p-panel header="{{ 'PRODUCTOCONTROL.LBL_CONTROLES' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colControles" [loading]="carTablaControles"
                     [value]="lisProductoControles" selectionMode="single" dataKey="idProductoControl"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.nombreFase}}</td>
                  <td>{{row.nombreControl}}</td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorSolicitudTradicional" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorPreaprobado" binary="true" disabled="true"></p-checkbox>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_CUESTIONARIOS' | translate}}"
                *ngIf="producto.indicadorCuestionario">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="colCuestionarios" [loading]="carTablaCuestionarios"
                   [value]="lisProductoCuestionarios" selectionMode="single" dataKey="idProductoCuestionario"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.nombreCuestionario}}</td>
                <td>{{row.ponderacion}}</td>
                <td>{{row.nombreEstado}}</td>
                <td>{{row.ponderacion}}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_DESEMBOLSO' | translate}}" *ngIf="producto.indicadorDesembolso">
      <p-panel header="{{ 'PRODUCTO.LBL_DESEMBOLSO' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colDesembolso" [loading]="carTablaDesembolso" #dt
                     [value]="lisProductoDesembolso" selectionMode="single" dataKey="idProducto"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of colDesembolso" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                      class="text-center"
                      [attr.colspan]="col.colspan" [attr.rowspan]="col.rowspan">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
                <tr>
                  <th *ngFor="let col of colDesembolso2" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                      class="text-center"
                      [attr.colspan]="col.span">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.rangoMontoAprobadoMinimo}}</td>
                  <td>{{row.rangoMontoAprobadoMaximo}}</td>
                  <td>{{row.rangoPlazoAprobadoMinimo}}</td>
                  <td>{{row.rangoPlazoAprobadoMaximo}}</td>
                  <td>{{row.rangoTasaProductoMinimo}}</td>
                  <td>{{row.rangoTasaProductoOrdinario}}</td>
                  <td>{{row.limiteDiaDesembolso}}</td>
                  <td>{{row.minimoDiaCantidadDesembolsoParcial}}</td>
                  <td>{{row.maximoDiaCantidadDesembolsoParcial}}</td>
                  <td>{{row.rangoAmpliarPlazoMinimoDia}}</td>
                  <td>{{row.rangoAmpliarPlazoMaximoDia}}</td>
                  <td>{{row.ampliarPlazo}}</td>
                  <td>{{row.diaMaximoMoraCliente}}</td>
                  <td>{{row.diaMaximoMoraProducto}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_DESTINO' | translate}}" *ngIf="!producto.indicadorMontoDestino && !producto.indicadorMontoDestinoPerfil">
      <app-producto-destino [producto]="producto" [verDetalle]="true" *ngIf="!producto.indicadorMontoDestino && !producto.indicadorMontoDestinoPerfil"></app-producto-destino>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_ESTADOS' | translate}}">
      <p-panel header="{{ 'PRODUCTOESTADO.LBL_ESTADOS' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colEstados" [loading]="carTablaEstado"
                     [value]="lisProductoEstados" selectionMode="single" dataKey="idProductoEstado"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.nombreEstado}}</td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">
                    <div class="btn-group" role="group">
                      <button type="button" class="p-button p-button-success btn" icon="fa fa-eye" data-toggle="tooltip"
                              title="{{'BTN_VISUALIZAR' | translate}}" pButton
                              (click)="abrirModalEstadoRelaciones(row)"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_FRECUENCIAS' | translate}}" >
      <p-panel header="{{ 'PRODUCTOFRECUENCIA.LBL_FRECUENCIAS' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colFrecuencias" [loading]="carTablaFrecuencias"
                     [value]="lisProductoFrecuencias" selectionMode="single" dataKey="idProductoFrecuencia"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.id}}</td>
                  <td>{{row.nombreFrecuenciaProducto}}</td>
                  <td class="text-center">
                    <div class="btn-group" role="group">
                      <button type="button" class="p-button p-button-success btn" icon="fa fa-eye" data-toggle="tooltip"
                              title="{{'BTN_AGREGAR' | translate}}" pButton
                              (click)="abrirModalFrecuenciaCuotas(row)"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTOFLUJOVENTA.LBL_FLUJOVENTA' | translate}}">
      <app-producto-flujo-venta-paso [producto]="producto" [detalle]="true" ></app-producto-flujo-venta-paso>
    </p-tabPanel>

    <p-tabPanel header="{{ 'PRODUCTO.LBL_HOJAEVALUACIONES' | translate}}"
                *ngIf="producto.indicadorHojaEvaluacion">
      <app-producto-hoja-evaluacion [producto]="producto"
                                    [detalle]="true"></app-producto-hoja-evaluacion>
    </p-tabPanel>

    <p-tabPanel header="{{ 'PRODUCTO.LBL_MONTOS' | translate}}" *ngIf="!producto?.indicadorMontoDestino && !producto?.indicadorMontoDestinoPerfil">
      <p-panel header="{{ 'PRODUCTOMONTO.LBL_MONTOS' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colMontos" [loading]="carTablaMontos"
                     [value]="lisProductoMontos" selectionMode="single" dataKey="idProductoMonto"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row let-i="rowIndex">
                <tr [pSelectableRow]="row">
                  <td>{{row.montoMinimo}} - {{row.montoMaximo}}</td>
                  <td>{{row.plazoMaximo}}</td>
                  <td>{{row.plazoMaximoGarantiaIdonea}}</td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorAnalizamos" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorFlujoDigital" binary="true" disabled="true"></p-checkbox>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_MONTOALIADO' | translate}}" *ngIf="producto.indicadorMontoDestinoPerfil">
      <app-producto-monto-aliado [verDetalle]="true" [producto]="producto" *ngIf="producto.indicadorMontoDestinoPerfil"></app-producto-monto-aliado>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_MONTOPORDESTINO' | translate}}" *ngIf="producto.indicadorMontoDestino">
      <app-producto-destino-monto [verDetalle]="true" [producto]="producto"  *ngIf="producto.indicadorMontoDestino"></app-producto-destino-monto>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_PLANESCARGOS' | translate}}">
      <p-panel header="{{ 'PRODUCTOPLANCARGO.LBL_PLANCARGO' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colPlanCargo" [loading]="carTablaPlanCargo"
                     [value]="lisProductoPlanCargo" selectionMode="single" dataKey="idProductoPlanCargo"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.formaDesembolso}}</td>
                  <td>{{row.planCargo}}</td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorDigital" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorTradicional" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorDefault" binary="true" disabled="true"></p-checkbox>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_PRODSEGUANAL' | translate}}">
      <app-producto-seguro-analizamos [producto]="producto" *ngIf="producto && producto.idProducto && lisProductoSeguroAnalizamos" [editar]="true"
      ></app-producto-seguro-analizamos>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_REFERENCIAS' | translate}}">
      <p-panel header="{{ 'PRODUCTOREFERENCIA.LBL_REFERENCIAS' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colReferencias" [loading]="carTablaReferencia"
                     [value]="lisProductoReferencias" selectionMode="single" dataKey="idProductoReferencia"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.tipoReferencia}}</td>
                  <td>{{row.tipoVinculacion}}</td>
                  <td>{{row.tipoPersona}}</td>
                  <td>{{row.numeroReferencias}}</td>
                  <td class="text-center">{{row.funcionalidad}}</td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorObligatorio" binary="true" disabled="true"></p-checkbox>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_REGLASNEGOCIO' | translate}}"
                *ngIf="producto.indicadorComercializacionOficinas">
      <p-panel header="{{ 'PRODUCTOREGLANEGOCIO.LBL_REGLANEGOCIO' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colReglasNegocio"
                     [value]="lisReglasNegocios" selectionMode="single" dataKey="idProductoReglaNegocio"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.nombreProductoRegla}}</td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorRecogerCreditos" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorPrimerCredito" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">{{row.mesesMaximoCancelacion}}</td>
                  <td class="text-center">{{row.porcentajeCancelacion}}</td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_RENOVACION' | translate}}" *ngIf="producto.indicadorRenovable">
      <p-panel header="{{ 'PRODUCTORENOVACION.LBL_RENOVACION' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colRenovacion" [loading]="carTablaRenovacion"
                     [value]="lisProductoRenovacion" selectionMode="single" dataKey="idProductoRenovacion"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.nombreFrecuenciaProducto}}</td>
                  <td>{{row.rangoPlazo}}</td>
                  <td>{{row.minimoCuotasPagas}}</td>
                  <td>{{row.perfilRiesgo}}</td>
                  <td>{{row.nivelAprueba}}</td>
                  <td>{{row.nivelExcepcion}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_RESPALDO' | translate}}" *ngIf="producto.indicadorManejaGarantia">
      <p-panel header="{{ 'PRODUCTOGARANTIA.LBL_RESPALDO' | translate}}">
        <p-fieldset legend="{{ 'PRODUCTOGARANTIA.LBL_TIPOGARANTIA' | translate }}" class="margin-botton-fieldset" *ngIf="producto.idTipoValor">
        <div class="grid col-12">
          <label class="lg:col-2 col-2 md:col-2 control-label">{{ 'PRODUCTOGARANTIA.LBL_TIPOVALOR' | translate }}:</label>
          <label class="lg:col-3 col-4 md:col-4"><strong>{{producto.tipoValor}}</strong></label>
        </div>
        </p-fieldset>
        <p-fieldset legend="{{ 'PRODUCTOGARANTIA.LBL_CONFORMACIONRESPALDOS' | translate }}">
        <div class="grid col-12">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colGarantias" [loading]="carTablaGarantias"
                     [value]="lisProductoGarantias" selectionMode="single" dataKey="idProductoGarantia"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.perfilRiesgo}}</td>
                  <td>{{row.rangoMonto}}</td>
                  <td>{{row.minimoCodeudores}}</td>
                  <td>{{row.nivelAprueba}}</td>
                  <td>{{row.nivelExcepcion}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        </p-fieldset>
      </p-panel>
    </p-tabPanel>
    <p-tabPanel header="{{ 'PRODUCTO.LBL_RESTRICCIONES' | translate}}" *ngIf="producto.indicadorComercializacionOficinas">
      <p-panel header="{{ 'PRODUCTO.LBL_RESTRICCIONESOFI' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colRestriccionOficina" [loading]="carTablaRestriccionOficina"
                     [value]="lisProductoRestriccionOficina" selectionMode="single" dataKey="idProductoGarantia"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.nombreOficina}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
      <p-panel header="{{ 'PRODUCTO.LBL_ASIGNACIONGEOGRAFICA' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="input-search-icon">
              <input
                size="40"
                type="text"
                pInputText
                placeholder="{{ 'LBL_BUSCAR' | translate }}"
                (input)="dt.filterGlobal($event.target.value, 'contains')"/>
              <i class="pi pi-search"></i>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-12">
            <p-table #dt [columns]="colRestriccionBarrio" [loading]="carTablaRestriccionBarrio"
                     [value]="lisProductoRestriccionBarrio" selectionMode="single" dataKey="idProductoGarantia"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.camino}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>

    <p-tabPanel header="{{ 'PRODUCTO.LBL_VOLUNTADPAGO' | translate}}" *ngIf="producto.indicadorComercializacionOficinas">
      <p-panel header="{{ 'PRODUCTO.LBL_VOLUNTADPAGO' | translate}}">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="colVoluntadPago" [loading]="carTablaVoluntadPago"
                     [value]="lisProductoVoluntadPago" selectionMode="single" dataKey="idProductoActividad"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.nombreCuestionario}}</td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </p-tabPanel>

    <p-tabPanel header="{{'GARANTIAPRODUCTOS.LBL_TITULO' | translate}}">
      <app-producto-garantia-idonea [producto]="producto" [esDetalle]="true">

      </app-producto-garantia-idonea>
    </p-tabPanel>


    <p-tabPanel header="{{ 'PRODUCTOCATEGORIAS.LBL_CATEGORIAS' | translate}}"
                *ngIf="codeTipoCuentaAhorro === tiposCuentaAhorro.AHORRO_PROGRAMADO">
      <app-producto-categorias [producto]="producto" [detalle]="true"
                               *ngIf="producto && producto.idProducto"></app-producto-categorias>
    </p-tabPanel>

    <p-tabPanel header="{{'PRODUCTO_PASARELA.LBL_TITULO' | translate}}" *ngIf="codeTipoProductoBancario == codigosProducto.PASARELA" [disabled]="!producto?.idProducto">
      <app-producto-pasarela *ngIf="producto?.idProducto" [isDetail]="true" [producto]="producto"></app-producto-pasarela>
    </p-tabPanel>

    <p-tabPanel header="{{'PRODUCTO_ADJUNTO.LBL_TITULO' | translate}}" *ngIf="producto?.idProducto && producto.indicadorAplicaAdjunto" [disabled]="codeTipoProductoBancario != codigosProducto.PASARELA">
      <app-producto-adjuntos *ngIf="codeTipoProductoBancario == codigosProducto.PASARELA" [isDetail]="true" [producto]="producto"></app-producto-adjuntos>
    </p-tabPanel>

  </p-tabView>

  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
              type="submit" (click)="regresar()"
              pButton></button>
    </div>
  </div>
</div>

<!-- MODAL RELACIONES DEL ESTADO -->
<p-dialog header="{{'PRODUCTOESTADO.LBL_RELACIONES' | translate}}"
          [draggable]="false"
          [resizable]="false"
          [(visible)]="mosEstadoRelaciones" [modal]="true"
          [style]="{width: '1100px', 'max-width': '96vw'}"
          appendTo="body"
          (onHide)="cerrarModalEstadoRelaciones()">
  <div class="grid" *ngIf="proEstadoSeleccionado">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="colEstadoRelaciones" [loading]="carTablaEstadoRelaciones"
               [value]="lisEstadoRelaciones"
               [paginator]="true" [rows]="10" paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" class="text-center">
              {{col.header}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{row.nombreEstadoPrincipal}}</td>
            <td>{{row.nombreEstado}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorMantieneFase" binary="true" disabled="true"></p-checkbox>
            </td>
            <td>{{row.nombreFuncionalidadPadre}}</td>
            <td>{{row.nombreFuncionalidadHijo}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorSolicitudTradicional" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">{{ row.preAprobado ? row.preAprobado : '-' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
              pButton (click)="cerrarModalEstadoRelaciones()"></button>
    </div>
  </div>
</p-dialog>

<!-- MODAL FRECUENCIAS-CUOTAS -->
<p-dialog header="{{'PRODUCTOFRECUENCIA.LBL_CUOTAS' | translate}}"
          *ngIf="showModalFrecuenciasCuotas"
          [(visible)]="showModalFrecuenciasCuotas" modal="true"
          [contentStyle]="{ width: '800px' }"
          appendTo="body"
          >
          <app-frecuencias-cuotas
          [productoFrecuencia]="proFrecuencia"
          [esDetalle]="true"
          (dismiss)="cerrarModalFrecuenciaCuotas()"
          ></app-frecuencias-cuotas>
</p-dialog>
